<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
        <div class="form-group col-md-12 mb-2">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>
        <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id" 
                                [class] ="DAT_AG_GRID.class" 
                                [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [rowSelection] = 'rowSelection'
                                [columnDefs]="columnDefs"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [allowContextMenuWithControlKey]="true"
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
    </ng-template>
    <!-- GRILLA -->
  </div>
  
    <!-- MODAL -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>
  
    <ng-template #abrirModal>
        <div class="container-fluid">
        <form [formGroup]="formulario" novalidate class="form-group">
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="idTipo" [label]="'ID TIPO '" [id]="'idTipo'" 
                    [control]="formulario.get('idTipo')" [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="nombre" [label]="'* Detalle Tipo'" [id]="'nombre'" 
                    [control]="formulario.get('nombre')" [placeholder]="'Nombre del tipo'" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Estado'" formControlName="estado" [control]="formulario.get('estado')" 
                                        [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Tipo de Escenario'" [mostrarImg]="false" formControlName="tipoEscenario" (change)="validaciones()" 
                    [control]="formulario.get('tipoEscenario')" [comboBox]="listCatalogos?.tipoEscenarios" 
                    [opcion]="'valor'" [idOpcion]="'valor'" class="form-control-sm" [id]="'tipoEscenario'">
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Tipo de Prioridad'" formControlName="prioridadKanban" 
                    [control]="formulario.get('prioridadKanban')" [comboBox]="listCatalogos?.prioridades" 
                    [opcion]="'valor'" [idOpcion]="'valor'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <label class="mb-2" for="generaTicketGarita">Genera ticket Garita</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="generaTicketGarita" id="generaTicketGarita" type="checkbox">
                        <label class="form-check-label" for="generaTicketGarita"> {{this.formulario.get('generaTicketGarita').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>

                <div class="col">
                    <label class="mb-2" for="generaTicketBalanza">Genera ticket Balanza</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="generaTicketBalanza" id="generaTicketBalanza" type="checkbox">
                        <label class="form-check-label" for="generaTicketBalanza"> {{this.formulario.get('generaTicketBalanza').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>

                <div class="col">
                    <label class="mb-2" for="georeferencia">GeoReferencia</label>
                    <div class="form-check">
                        <input (change)="validaciones()" class="form-check-input" formControlName="georeferencia" id="georeferencia" type="checkbox">
                        <label class="form-check-label" for="georeferencia"> {{this.formulario.get('georeferencia').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>

                <div class="col">
                    <app-lfsa-input formControlName="georeferenciaTiempo" [label]="'GPS Tiempo'" [id]="'georeferenciaTiempo'" [control]="formulario.get('georeferenciaTiempo')" 
                    [type]="'number'" class="form-control-sm" [isReadOnly]="!formulario.get('georeferencia').value">
                    </app-lfsa-input>
                </div>

                <div class="col">
                    <app-lfsa-input formControlName="georeferenciaRango" [label]="'GPS Rango (KM)'" [id]="'georeferenciaRango'" [control]="formulario.get('georeferenciaRango')" 
                     [type]="'number'" class="form-control-sm" [isReadOnly]="!formulario.get('georeferencia').value">
                    </app-lfsa-input>
                </div>                
            </div>

            <!--APLICACION POR ESCENARIOS-->
            <!--VALORES PARA VENTAS-->
            <div class="row" *ngIf="this.formulario.get('tipoEscenario').value == 'VENTA'">
                <div class="alert alert-warning" role="alert">
                    Ventas : toda venta requiere cliente, origen y almacen de despacho
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereOrden">Requiere Orden</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereOrden" id="requiereOrden" type="checkbox">
                        <label class="form-check-label" for="requiereOrden"> {{this.formulario.get('requiereOrden').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>

                <div class="col">
                    <label class="mb-2" for="requiereBuque">Requiere Buque</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereBuque" id="requiereBuque" type="checkbox">
                        <label class="form-check-label" for="requiereBuque"> {{this.formulario.get('requiereBuque').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="this.formulario.get('tipoEscenario').value == 'COMPRA' ">
                <div class="alert alert-warning" role="alert">
                    - Compras : toda compra requiere proveedor, origen y almacen de destino.
                    - Requiere origen : activa los campos del origen, pesos de la extractora y campos de calidad
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereOrigen">Requiere Valores de Origen</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereOrigen" id="requiereOrigen" type="checkbox">
                        <label class="form-check-label" for="requiereOrigen"> {{this.formulario.get('requiereOrigen').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereOrden">Requiere Orden</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereOrden" id="requiereOrden" type="checkbox">
                        <label class="form-check-label" for="requiereOrden"> {{this.formulario.get('requiereOrden').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereBuque">Requiere Buque</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereBuque" id="requiereBuque" type="checkbox">
                        <label class="form-check-label" for="requiereBuque"> {{this.formulario.get('requiereBuque').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereTanquero">Requiere Número de Tanquero</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereTanquero" id="requiereTanquero" type="checkbox">
                        <label class="form-check-label" for="requiereTanquero"> {{this.formulario.get('requiereTanquero').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
            </div>
            
            <div class="row">                
                <div class="alert alert-secondary"role="alert">
                    - Área Planificacion : activa la selección de áreas dependiente del centro destino.
                </div>
                <div class="col">
                    <label class="mb-2" for="requiereArea">Requiere selección de área</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereArea" id="requiereArea" type="checkbox">
                        <label class="form-check-label" for="requiereArea"> {{this.formulario.get('requiereArea').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div>
                <!-- se comenta hasta revisar bien los procesos con los check
                <div class="col">
                    <label class="mb-2" for="requiereCheck">Requiere registro/check</label>
                    <div class="form-check">
                        <input class="form-check-input" formControlName="requiereCheck" id="requiereCheck" type="checkbox">
                        <label class="form-check-label" for="requiereCheck"> {{this.formulario.get('requiereCheck').value ? 'Si' : 'No'}}
                        </label>
                    </div>
                </div> -->
            </div>

            <br><hr>
            <p>Control de Registro</p>
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="creadoPor" [label]="'* Creado por'" [id]="'creadoPor'" [control]="formulario.get('creadoPor')" 
                    [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="modificadoPor" [label]="'* Modificado por'" [id]="'modificadoPor'" [control]="formulario.get('modificadoPor')" 
                    [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
            </div>
            <!-- [mostrarBotonVerde] = "isCreate" -->
            <app-lfsa-botones-formulario
                (devolverAccion) ="acciones($event)" 
                [formularioValido] ="formulario.invalid"
                [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
            </app-lfsa-botones-formulario>

        </form>
        </div>

    </ng-template>
    <!-- END MODAL --> 




